import { Page } from '@/core/architecture'

import { ResaleApplicationCreateCompletionTemplate } from './template'
import { useViewModel } from './viewModel'

/**
 * ResaleApplicationCreateCompletion Page
 * Implemented as a practical sample.
 */
export const ResaleApplicationCreateCompletion: Page = () => {
  const { state, actions } = useViewModel()

  return (
    <ResaleApplicationCreateCompletionTemplate state={state} {...actions} />
  )
}
